module.exports = __webpack_public_path__ + "51ba9289c16284658552f53c99ec914a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/grails-db.png
// module id = 255
// module chunks = 1